import { createContext } from "react";

const trackingContext = createContext();

export default trackingContext;
